module.exports = __webpack_public_path__ + "static/media/NoTeams.b00de76d.svg";